import React from 'react';
export function SentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__5e9bb__clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.16 2.745L21.254.841.188 8.602l2.175 2.175 6 4 .86.86 4 6 2.175 2.175 7.761-21.067zM9.18 12.918l-5.311-3.54L20.745 3.16l.095.095-6.217 16.876-3.54-5.31L16.5 8.5l-1-1-6.32 5.418z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__5e9bb__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}